import React, { memo } from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function AudienceSection() {
  const audiences = ["Those who followed the case and felt the media didn't tell the full story.", 'Students and young people asking what it means to defend ideas in a world that cancels before it debates.', 'Parents who want resources to talk about free speech with their children.', 'Anyone — regardless of political views — who believes memory matters.', 'Collectors of historical documents: memorials, archives, period chronicles.', 'Those who believe that understanding the present is the only way to shape the future.'];
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        {/* Section label */}
        <FadeIn data-id="element-22">
          <div className="flex items-center gap-4 mb-16" data-id="element-23">
            <div className="h-px bg-border-accent flex-grow" data-id="element-24" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-25">
              ◆ The Reader ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-26" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-27">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-16 text-center leading-tight" data-id="element-28">
            Who This Book Is For
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-29">
          {audiences.map((audience, index) => <FadeIn key={index} delay={0.15 + index * 0.06} data-id="element-30">
              <div className="flex items-start gap-6 p-6 rounded-sm bg-surface border border-border-default hover:border-accent-muted transition-colors duration-300" data-id="element-31">
                <div className="mt-1 bg-elevated p-2 rounded-full border border-border-accent" data-id="element-32">
                  <Check className="w-5 h-5 text-accent-primary" data-id="element-33" />
                </div>
                <p className="font-body text-xl text-text-secondary leading-relaxed" data-id="element-34">
                  {audience}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* CTA */}
        <FadeIn delay={0.6} data-id="element-35">
          <div className="flex flex-col items-center mt-14 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-36">
            <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-37">
              If any of this resonates — this book was written for you.
            </p>
            <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-38">
              Get The Memorial Edition &rarr;
            </Button>
            <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-39">
              170 pages. Instant access. Yours forever.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}